import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const TeamPrivacySetting = ({ disabled }) => {
    const [privacy, setPrivacy] = React.useState("open");

    const handleChange = (event) => {
        setPrivacy(event.target.value);
    };

    return (
        <Box style={{ width: "100%" }}>
            <FormControl fullWidth>
                <Select
                    disabled={disabled}
                    labelId="team-privacy-label"
                    id="team-privacy-select"
                    value={privacy}
                    onChange={handleChange}
                >
                    <MenuItem value="open">Open Team</MenuItem>
                    <MenuItem value="private">Private Team</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export default TeamPrivacySetting;
